var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","clipRule":"evenodd","d":"M12.8555 4C8.44004 4 4.85547 7.58457 4.85547 12C4.85547 16.4154 8.44004 20 12.8555 20C17.2709 20 20.8555 16.4154 20.8555 12C20.8555 7.58457 17.2709 4 12.8555 4ZM2.85547 12C2.85547 6.48 7.33547 2 12.8555 2C18.3755 2 22.8555 6.48 22.8555 12C22.8555 17.52 18.3755 22 12.8555 22C7.33547 22 2.85547 17.52 2.85547 12ZM11.8555 17V15H13.8555V17H11.8555ZM11.8555 7V13H13.8555V7H11.8555Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
